<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  [appearance]="'compact'"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.compact"
  [opened]="!isScreenSmall"
  class="bg-primary-500 text-white print:hidden">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- Logo -->
    <div class="flex items-center justify-center h-20 mt-3 mb-4">
      <img
        alt="Logo image"
        class="w-10"
        src="assets/images/iso/iso.svg">
    </div>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

  <!-- Header -->
  <div
    class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
    <!-- Navigation toggle button -->
    <button
      (click)="toggleNavigation('mainNavigation')"
      mat-icon-button>
      <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
    </button>
    <h2 class="text-xl font-semibold">{{ title$.title | async | uppercase }}</h2>
    <!-- Components -->
    <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
      <!--      <languages></languages>-->
      <!--      <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>-->
      <!--      <search [appearance]="'bar'"></search>-->
      <!--      <shortcuts></shortcuts>-->
      <!--      <messages></messages>-->
      <!--      <notifications></notifications>-->
      <!--      <button-->
      <!--        class="lg:hidden"-->
      <!--        mat-icon-button-->
      <!--        (click)="quickChat.toggle()">-->
      <!--        <mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'"></mat-icon>-->
      <!--      </button>-->
      <user></user>
      <!--      <img-->
      <!--        class="w-full h-full rounded-full"-->
      <!--        *ngIf="user.avatar"-->
      <!--        [src]="user.avatar"-->
      <!--        referrerpolicy="no-referrer"-->
      <!--        alt="User avatar">-->
      <!--      <mat-icon-->
      <!--        class="icon-size-24"-->
      <!--        *ngIf="!user.avatar"-->
      <!--        [svgIcon]="'heroicons_solid:user-circle'"></mat-icon>-->
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
         Otherwise, layout changes won't be registered and the view won't be updated! -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>

  <!-- Footer -->
  <div
    class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
    <span class="font-medium text-secondary">Centro Terapéutico Cubic&copy; {{ currentYear }}</span>
  </div>

</div>

<!-- Quick chat -->
<!--<quick-chat #quickChat="quickChat"></quick-chat>-->
